import { Route } from '@angular/router';
import { ProfileComponent } from './profile.component';
import { GeneralProfileComponent } from './general/general.component';
import { NotificationsProfileComponent } from './notifications/notifications.component';
import { Permission } from 'app/core/enums';
import { AuthorizationGuard } from 'app/core/guards/authorization.guard';

export const profileRoutes: Route[] = [
  {
    path: '',
    component: ProfileComponent,
    children: [
      {
        path: '',
        redirectTo: 'general',
        pathMatch: 'full',
      },
      {
        path: 'general',
        component: GeneralProfileComponent,
      },
      {
        path: 'notifications',
        canActivate: [AuthorizationGuard],
        component: NotificationsProfileComponent,
      },
    ],
  },
];
